import { ReactComponent as LungIcon } from '../../../../assets/icons/Lung.svg'
import { ReactComponent as HeartIcon } from '../../../../assets/icons/HeartBeat.svg'
import { ReactComponent as SkinIcon } from '../../../../assets/icons/BrightSkin.svg'
import { ReactComponent as BloodPressureIcon } from '../../../../assets/icons/BloodPressure.svg'
import { ReactComponent as BrainIcon } from '../../../../assets/icons/MentalDisorder.svg'
import { ReactComponent as MoonIcon } from '../../../../assets/icons/Moon.svg'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { getEcgReportFile } from '../../../../services/TricogService'
dayjs.extend(isoWeek)

export const DEVICE_VITAL_COMPONENTS = {
  HEART_RATE: 'Heart Rate',
  SPO2: 'Spo2',
  BLOOD_PRESSURE_SYSTOLIC: 'Blood Pressure Systolic',
  BLOOD_PRESSURE_DIASTOLIC: 'Blood Pressure Diastolic',
  SKIN_TEMPERATURE: 'Skin Temperature',
  RESPIRATORY_RATE: 'Respiratory Rate',
  HEART_RATE_VAR: 'Heart Rate Var',
  STRESS: 'Stress',
  SLEEP: 'Sleep',
  BLOOD_GLUCOSE: 'Blood Glucose',
  ACTIVITY: 'Activity Monitor',
}

export const DEVICE_VITAL_COMPONENTS_ARRAY = [
  { label: 'Heart Rate', value: 'heartRate' },
  { label: 'Spo2', value: 'spo2' },
  { label: 'Blood Pressure Systolic', value: 'bloodPressureSystolic' },
  { label: 'Blood Pressure Diastolic', value: 'bloodPressureDiastolic' },
  { label: 'Skin Temperature', value: 'skinTemperature' },
  { label: 'Respiratory Rate', value: 'respiratoryRate' },
  { label: 'Heart Rate Var', value: 'heartRateVar' },
  { label: 'Stress', value: 'stress' },
  { label: 'Sleep', value: 'sleep' },
  { label: 'Blood Glucose', value: 'bloodGlucose' },
]

export const DEVICE_VITAL_OVERVIEW_PRORITHM: {
  key: string
  label: string
  icon: any
}[] = [
  { key: 'heartRate', label: 'Heart Rate', icon: HeartIcon },

  { key: 'spo2', label: 'Spo2', icon: LungIcon },
  {
    key: 'bloodPressureSystolic',
    label: 'Blood Pressure Systolic',
    icon: BloodPressureIcon,
  },
  {
    key: 'bloodPressureDiastolic',
    label: 'Blood Pressure Diastolic',
    icon: BloodPressureIcon,
  },
  { key: 'skinTemperature', label: 'Skin Temperature', icon: SkinIcon },
  { key: 'respiratoryRate', label: 'Respiratory Rate', icon: LungIcon },
  { key: 'heartRateVar', label: 'Heart Rate Var', icon: HeartIcon },
]

export const DEVICE_VITAL_OVERVIEW_SMART_RING: {
  key: string
  label: string
  icon: any
}[] = [
  { key: 'heartRate', label: 'Heart Rate', icon: HeartIcon },
  { key: 'spo2', label: 'Spo2', icon: LungIcon },
  { key: 'skinTemperature', label: 'Skin Temperature', icon: SkinIcon },
  { key: 'heartRateVar', label: 'Heart Rate Var', icon: HeartIcon },
  { key: 'stress', label: 'Stress', icon: BrainIcon },
  { key: 'sleep', label: 'Sleep', icon: MoonIcon },
]

// Mapping of vital keys to their names and units
export const vitalMappings = [
  { key: 'hr', name: 'Heart Beat', unit: 'BPM', safeKey: 'heartBeat' },
  { key: 'spo2', name: 'SpO2', unit: '%', safeKey: 'spo2' },
  {
    key: 'bp',
    name: 'Blood Pressure Systolic',
    unit: 'mmHg',
    safeKey: 'bpSystolic',
    subKey: 'sp',
  },
  {
    key: 'bp',
    name: 'Blood Pressure Diastolic',
    unit: 'mmHg',
    safeKey: 'bpDiastolic',
    subKey: 'dp',
  },
  {
    key: 'skt',
    name: 'Skin Temperature',
    unit: '°F',
    safeKey: 'skinTemperature',
  },
  {
    key: 'rr',
    name: 'Respiratory Rate',
    unit: 'breaths/min',
    safeKey: 'respiratoryRate',
  },
  {
    key: 'hrv',
    name: 'Heart Rate Variability',
    unit: 'ms',
    safeKey: 'heartRateVar',
  },
]

export const safeRangeKeys = {
  HEARTRATE: 'heartRate',
  SPO2: 'spo2',
  BLOODPRESSURESYSTOLIC: 'bloodPressureSystolic',
  BLOODPRESSUREDIASTOLIC: 'bloodPressureDiastolic',
  SKINTEMPERATURE: 'skinTemperature',
  RESPIRATORYRATE: 'respiratoryRate',
  HEARTRATEVAR: 'heartRateVar',
  STRESS: 'stress',
  SLEEP: 'sleep',
  BLOODGLUCOSE: 'bloodGlucose',
}

// Function to determine color based on value range
export const getColor = (
  safeRanges: Record<string, { min: number; max: number }>,
  key: string,
  value: number | string
) => {
  if (typeof value !== 'number') return 'black'

  const range = safeRanges[key]
  if (!range) return 'black'

  return value < range.min || value > range.max ? 'red' : 'green'
}

// Function to determine color based on value range for Icons
export const getIconColor = (
  safeRanges: Record<string, { min: number; max: number }>,
  key: string,
  value: number | string
) => {
  if (
    typeof value !== 'number' ||
    value === null ||
    value === undefined ||
    isNaN(value) ||
    value === 0
  )
    return 'grey'

  const range = safeRanges[key]
  if (!range) return 'grey'
  return value < range.min || value > range.max ? 'red' : 'green'
}

export const DATE_DIRECTIONS = {
  NEXT: 'next',
  PREVIOUS: 'prev',
}

export const GRAPH_PERIODS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
}

export const VITAL_KEYS = {
  HEART_RATE: 'heartRate',
  HRV: 'hrv',
  SKIN_TEMP: 'temperature',
  SLEEP_TRACKING: 'sleep',
  SPO2: 'spo2',
  STRESS: 'stress',
  BLOOD_PRESSURE: 'bp',
  BLOOD_GLUCOSE: 'bg',
  ACTIVITY: 'activity',
}

export const ERROR_DEVICES_SCREEN =
  'Please Select the Patient to acccess devices'

export const backgroundImage =
  'data:image/svg+xml;base64,' +
  btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
      <defs>
        <pattern id="smallGrid" width="10" height="10" patternUnits="userSpaceOnUse">
          <path d="M 10 0 L 0 0 0 10" fill="none" stroke="#ddd" stroke-width="0.5"/>
        </pattern>
        <pattern id="grid" width="50" height="50" patternUnits="userSpaceOnUse">
          <rect width="50" height="50" fill="url(#smallGrid)"/>
          <path d="M 50 0 L 0 0 0 50" fill="none" stroke="#aaa" stroke-width="1"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" />
    </svg>
  `)

export const VISIT_STATUS_FINISHED = 'finished'
export const BLOOD_PRESSURE_TYPES = {
  SYSTOLIC: 'Blood Pressure Systolic',
  DIASTOLIC: 'Blood Pressure Diastolic',
}

export const TRICOG_ROLES = [
  {
    label: 'Doctor',
    value: 'doctor',
  },
  {
    label: 'Nurse',
    value: 'nurse',
  },
  {
    label: 'Tricog',
    value: 'tricog',
  },
]

export const API_VERSION_V3 = 'v3'
export const API_VERSION_V2 = 'v2'

export const convertTo12Hour = (time: any) => {
  const [hours, minutes] = time.split(':')
  let hours1 = hours
  hours1 = parseInt(hours1)
  const period = hours1 >= 12 ? 'PM' : 'AM'
  hours1 = hours1 % 12 || 12
  return `${String(hours1)?.padStart(2, '0')}:${minutes} ${period}`
}

export const getFormattedTime = (date: any) => {
  const newdate = new Date(date)
  const formattedTime = newdate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
  return formattedTime
}

/* eslint-disable */
export const stages = [
  {
    title: 'What is Awake',
    description:
      'The wakefulness stage refers to periods when the user remains awake during the overall sleep process. This includes the time before falling asleep, any nighttime awakenings, and the final awakening in the morning. Monitoring this stage helps assess the continuity and stability of sleep, as the length and frequency of wakefulness significantly impact sleep quality. By accurately detecting these awake periods, the app can help users identify potential disruptions—such as environmental factors, emotional stress, or health conditions. With these insights, users can take targeted actions, like optimizing their sleep environment or adjusting bedtime routines, to improve overall sleep depth and consistency.',
    idealRange: '15-20',
  },
  {
    title: 'What is REM',
    description:
      'The wakefulness stage refers to periods when the user remains awake during the overall sleep process. This includes the time before falling asleep, any nighttime awakenings, and the final awakening in the morning. Monitoring this stage helps assess the continuity and stability of sleep, as the length and frequency of wakefulness can significantly impact sleep quality. By accurately detecting these awake periods, the app can help users identify potential disruptions—such as environmental factors, emotional stress, or health conditions. With these insights, users can take targeted actions, like optimizing their sleep environment or adjusting bedtime routines, to improve overall sleep depth and consistency.',
    idealRange: '20-25',
  },
  {
    title: 'What is Light Sleep',
    description: `The wakefulness stage refers to periods when the user remains awake during the overall sleep process. This includes the time before falling asleep, any nighttime awakenings, and the final awakening in the morning. Monitoring this stage helps assess the continuity and stability of sleep, as the length and frequency of wakefulness can significantly impact sleep quality. By accurately detecting these awake periods, the app can help users identify potential disruptions—such as environmental factors, emotional stress, or health conditions. With these insights, users can take targeted actions, like optimizing their sleep environment or adjusting bedtime routines, to improve overall sleep depth and consistency.`,
    idealRange: '45-55',
  },
  {
    title: 'What is Deep Sleep',
    description: `The wakefulness stage refers to periods when the user remains awake during the overall sleep process. This includes the time before falling asleep, any nighttime awakenings, and the final awakening in the morning. Monitoring this stage helps assess the continuity and stability of sleep, as the length and frequency of wakefulness can significantly impact sleep quality. By accurately detecting these awake periods, the app can help users identify potential disruptions—such as environmental factors, emotional stress, or health conditions. With these insights, users can take targeted actions, like optimizing their sleep environment or adjusting bedtime routines, to improve overall sleep depth and consistency.`,
    idealRange: '15-20',
  },
]
/* eslint-disable */

// Preserving old version

// export const getStartAndEndDate = (date: dayjs.Dayjs, period: string) => {
//   let startDate = date
//   let endDate = date

//   if (period === GRAPH_PERIODS.WEEK) {
//     startDate = date.startOf('week')
//     endDate = date.endOf('week')
//   } else if (period === GRAPH_PERIODS.MONTH) {
//     startDate = date.startOf('month')
//     endDate = date.endOf('month')
//   }

//   // For day, start and end are the same
//   return { startDate, endDate }
// }

// Preserving old version

export const getStartAndEndDate = (date: dayjs.Dayjs, period: string) => {
  let startDate = date
  let endDate = date

  if (period === GRAPH_PERIODS.WEEK) {
    startDate = date.startOf('isoWeek') // Monday
    endDate = date.endOf('isoWeek') // Sunday
  } else if (period === GRAPH_PERIODS.MONTH) {
    startDate = date.startOf('month')
    endDate = date.endOf('month')
  }

  return { startDate, endDate }
}

export const getEcgFile = async (fileName: string) => {
  const response = await getEcgReportFile(fileName)
  if (response?.success) {
    const blob = new Blob([response?.data], { type: 'application/pdf' })
    const file = new File([blob], fileName, { type: 'application/pdf' })
    const url = URL.createObjectURL(blob)
    return { pdfFile: file, pdfFileUrl: url }
  }
  return {}
}

export const TRICOG_FILE_ERROR_MESSAGE = 'Please upload a valid PDF file'
